module.exports = __webpack_public_path__ + "static/media/nunta-icon.516e0d6f.svg";